import { ReactNode, JSX } from 'react';
import { useMediaQuery, useTheme, Breakpoint } from '@mui/material';

type WidthType =
  | 'xsDown'
  | 'smDown'
  | 'mdDown'
  | 'lgDown'
  | 'xlDown'
  | 'xsUp'
  | 'smUp'
  | 'mdUp'
  | 'lgUp'
  | 'xlUp';

interface MHiddenProps {
  children?: ReactNode;
  width: WidthType;
}

export default function MHidden({ width, children }: MHiddenProps): JSX.Element | null {
  const theme = useTheme();
  const breakpoint = width.substring(0, 2) as Breakpoint;

  const hiddenUp = useMediaQuery(theme.breakpoints.up(breakpoint));
  const hiddenDown = useMediaQuery(theme.breakpoints.down(breakpoint));

  if (width.includes('Down')) {
    return hiddenDown ? null : <>{children}</>;
  }

  if (width.includes('Up')) {
    return hiddenUp ? null : <>{children}</>;
  }

  return null;
}
